import './SelectStatus.css';

import { useEffect, useState } from 'react';

import { servGetAllStatusEmAberto } from '../../servicos/servicosEmRotasPrivadas/status';

function SelectStatus({ setStatus }) {

    const [statusList, setStatusList] = useState([])

    useEffect(() => {
        getAllStatus()
    }, []);

    const getAllStatus = async () => {
        try {
            const statusDaApi = await servGetAllStatusEmAberto()
            setStatusList(statusDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    const handleChange = (e) => {
        const value = e.target.value || null; // Se for "" transforma em null
        setStatus(value)
    };

    return (
        <div>
            {statusList ? (
                <div className="d-flex flex-column flex-md-row gap-1 p-1 align-items-center">
                    <label className='text-nowrap' htmlFor='status'>Status</label>
                    <select
                        className="form-control-sm w-100"
                        id="status"
                        defaultValue=""
                        onChange={handleChange}
                    >
                        <option value="">Selecione uma opção</option>
                        {statusList.map((status) => (
                            <option key={status.id} value={status.id}>
                                {status.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos status...</p>
            )}
        </div>
    )
}

export default SelectStatus